/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var enums_pb = require('./enums_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.exportSymbol('proto.UT.PROTO.SuperOrderBookRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.SuperOrderBookResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_ErrorResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_IcebergConfiguration', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_OrderResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_POVConfiguration', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_EventType', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_ExecutionMethod', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_FeEventType', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_OrderStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_SliceStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_StrategyStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SM_TransactionType', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SmartOrder', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SmartOrderType', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_SuperBocoConfiguration', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_TWAPConfiguration', null, global);
goog.exportSymbol('proto.UT.PROTO.WEB_ValidationError', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_TWAPConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_TWAPConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_TWAPConfiguration.displayName = 'proto.UT.PROTO.WEB_TWAPConfiguration';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_TWAPConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_TWAPConfiguration} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    sliceInterval: jspb.Message.getFieldWithDefault(msg, 1, 0),
    regenerateEnabled: jspb.Message.getFieldWithDefault(msg, 2, false),
    userDefinedInterval: jspb.Message.getFieldWithDefault(msg, 3, false),
    triggerPrice: jspb.Message.getFieldWithDefault(msg, 4, 0),
    modifyCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    timerSeconds: jspb.Message.getFieldWithDefault(msg, 6, 0),
    shiftToLimitPriceTimer: jspb.Message.getFieldWithDefault(msg, 7, 0),
    minMarginRequired: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_TWAPConfiguration}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_TWAPConfiguration;
  return proto.UT.PROTO.WEB_TWAPConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_TWAPConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_TWAPConfiguration}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSliceInterval(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRegenerateEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserDefinedInterval(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTriggerPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setModifyCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimerSeconds(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShiftToLimitPriceTimer(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinMarginRequired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_TWAPConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_TWAPConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_TWAPConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSliceInterval();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRegenerateEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUserDefinedInterval();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTriggerPrice();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getModifyCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTimerSeconds();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getShiftToLimitPriceTimer();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMinMarginRequired();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 slice_interval = 1;
 * @return {number}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getSliceInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setSliceInterval = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional bool regenerate_enabled = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getRegenerateEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setRegenerateEnabled = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional bool user_defined_interval = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getUserDefinedInterval = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setUserDefinedInterval = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional int64 trigger_price = 4;
 * @return {number}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getTriggerPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setTriggerPrice = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int32 modify_count = 5;
 * @return {number}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getModifyCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setModifyCount = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional int32 timer_seconds = 6;
 * @return {number}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getTimerSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setTimerSeconds = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int32 shift_to_limit_price_timer = 7;
 * @return {number}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getShiftToLimitPriceTimer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setShiftToLimitPriceTimer = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional int64 min_margin_required = 8;
 * @return {number}
 */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.getMinMarginRequired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_TWAPConfiguration.prototype.setMinMarginRequired = function(value) {
  jspb.Message.setField(this, 8, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_IcebergConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_IcebergConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_IcebergConfiguration.displayName = 'proto.UT.PROTO.WEB_IcebergConfiguration';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_IcebergConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_IcebergConfiguration} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    depth: jspb.Message.getFieldWithDefault(msg, 1, 0),
    thresholdPercent: jspb.Message.getFieldWithDefault(msg, 2, 0),
    singleOrderQty: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderValidity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    triggerPrice: jspb.Message.getFieldWithDefault(msg, 5, 0),
    lastExecutionPrice: jspb.Message.getFieldWithDefault(msg, 6, 0),
    totalOrdersPlaced: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ordersFilled: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ordersCancelled: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_IcebergConfiguration}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_IcebergConfiguration;
  return proto.UT.PROTO.WEB_IcebergConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_IcebergConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_IcebergConfiguration}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDepth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThresholdPercent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSingleOrderQty(value);
      break;
    case 4:
      var value = /** @type {!proto.UT.PROTO.OrderValidity} */ (reader.readEnum());
      msg.setOrderValidity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTriggerPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastExecutionPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalOrdersPlaced(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdersFilled(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdersCancelled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_IcebergConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_IcebergConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_IcebergConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDepth();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getThresholdPercent();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSingleOrderQty();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOrderValidity();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTriggerPrice();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getLastExecutionPrice();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalOrdersPlaced();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getOrdersFilled();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getOrdersCancelled();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional int32 depth = 1;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setDepth = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 threshold_percent = 2;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getThresholdPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setThresholdPercent = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 single_order_qty = 3;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getSingleOrderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setSingleOrderQty = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional OrderValidity order_validity = 4;
 * @return {!proto.UT.PROTO.OrderValidity}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getOrderValidity = function() {
  return /** @type {!proto.UT.PROTO.OrderValidity} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.UT.PROTO.OrderValidity} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setOrderValidity = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int64 trigger_price = 5;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getTriggerPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setTriggerPrice = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional int64 last_execution_price = 6;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getLastExecutionPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setLastExecutionPrice = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int32 total_orders_placed = 7;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getTotalOrdersPlaced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setTotalOrdersPlaced = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional int32 orders_filled = 8;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getOrdersFilled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setOrdersFilled = function(value) {
  jspb.Message.setField(this, 8, value);
};


/**
 * optional int32 orders_cancelled = 9;
 * @return {number}
 */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.getOrdersCancelled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_IcebergConfiguration.prototype.setOrdersCancelled = function(value) {
  jspb.Message.setField(this, 9, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_SuperBocoConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_SuperBocoConfiguration.displayName = 'proto.UT.PROTO.WEB_SuperBocoConfiguration';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_SuperBocoConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_SuperBocoConfiguration} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetPrice: jspb.Message.getFieldWithDefault(msg, 1, 0),
    targetEnabled: jspb.Message.getFieldWithDefault(msg, 2, false),
    stopLossPrice: jspb.Message.getFieldWithDefault(msg, 3, 0),
    stopLossEnabled: jspb.Message.getFieldWithDefault(msg, 4, false),
    trailStopLossPercentage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    trailStopLossEnabled: jspb.Message.getFieldWithDefault(msg, 6, false),
    trailJump: jspb.Message.getFieldWithDefault(msg, 7, 0),
    triggerPrice: jspb.Message.getFieldWithDefault(msg, 8, 0),
    triggerPriceEnabled: jspb.Message.getFieldWithDefault(msg, 9, false),
    ltpOnOrderCreation: jspb.Message.getFieldWithDefault(msg, 10, 0),
    currentTrailPrice: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_SuperBocoConfiguration}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_SuperBocoConfiguration;
  return proto.UT.PROTO.WEB_SuperBocoConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_SuperBocoConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_SuperBocoConfiguration}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTargetPrice(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTargetEnabled(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStopLossPrice(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStopLossEnabled(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrailStopLossPercentage(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrailStopLossEnabled(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrailJump(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTriggerPrice(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTriggerPriceEnabled(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLtpOnOrderCreation(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentTrailPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_SuperBocoConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_SuperBocoConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetPrice();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTargetEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getStopLossPrice();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getStopLossEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTrailStopLossPercentage();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getTrailStopLossEnabled();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getTrailJump();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTriggerPrice();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTriggerPriceEnabled();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getLtpOnOrderCreation();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCurrentTrailPrice();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional int64 target_price = 1;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTargetPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTargetPrice = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional bool target_enabled = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTargetEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTargetEnabled = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 stop_loss_price = 3;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getStopLossPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setStopLossPrice = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional bool stop_loss_enabled = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getStopLossEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setStopLossEnabled = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int64 trail_stop_loss_percentage = 5;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTrailStopLossPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTrailStopLossPercentage = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional bool trail_stop_loss_enabled = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTrailStopLossEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTrailStopLossEnabled = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int64 trail_jump = 7;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTrailJump = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTrailJump = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional int64 trigger_price = 8;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTriggerPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTriggerPrice = function(value) {
  jspb.Message.setField(this, 8, value);
};


/**
 * optional bool trigger_price_enabled = 9;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getTriggerPriceEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setTriggerPriceEnabled = function(value) {
  jspb.Message.setField(this, 9, value);
};


/**
 * optional int64 ltp_on_order_creation = 10;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getLtpOnOrderCreation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setLtpOnOrderCreation = function(value) {
  jspb.Message.setField(this, 10, value);
};


/**
 * optional int64 current_trail_price = 11;
 * @return {number}
 */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.getCurrentTrailPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SuperBocoConfiguration.prototype.setCurrentTrailPrice = function(value) {
  jspb.Message.setField(this, 11, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_POVConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_POVConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_POVConfiguration.displayName = 'proto.UT.PROTO.WEB_POVConfiguration';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_POVConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_POVConfiguration} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_POVConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    percentageOfVolume: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    interval: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bulkQtyThreshold: jspb.Message.getFieldWithDefault(msg, 3, 0),
    regenerateEnabled: jspb.Message.getFieldWithDefault(msg, 4, false),
    triggerPrice: jspb.Message.getFieldWithDefault(msg, 5, 0),
    modifyCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    timerSeconds: jspb.Message.getFieldWithDefault(msg, 7, 0),
    shiftToLimitPriceTimer: jspb.Message.getFieldWithDefault(msg, 8, 0),
    minMarginRequired: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_POVConfiguration}
 */
proto.UT.PROTO.WEB_POVConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_POVConfiguration;
  return proto.UT.PROTO.WEB_POVConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_POVConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_POVConfiguration}
 */
proto.UT.PROTO.WEB_POVConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentageOfVolume(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBulkQtyThreshold(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRegenerateEnabled(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTriggerPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setModifyCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimerSeconds(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShiftToLimitPriceTimer(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinMarginRequired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_POVConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_POVConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_POVConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentageOfVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBulkQtyThreshold();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRegenerateEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTriggerPrice();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getModifyCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTimerSeconds();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getShiftToLimitPriceTimer();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getMinMarginRequired();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional double percentage_of_volume = 1;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getPercentageOfVolume = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setPercentageOfVolume = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 interval = 2;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setInterval = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 bulk_qty_threshold = 3;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getBulkQtyThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setBulkQtyThreshold = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional bool regenerate_enabled = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getRegenerateEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setRegenerateEnabled = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int64 trigger_price = 5;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getTriggerPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setTriggerPrice = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional int32 modify_count = 6;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getModifyCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setModifyCount = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int32 timer_seconds = 7;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getTimerSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setTimerSeconds = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional int32 shift_to_limit_price_timer = 8;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getShiftToLimitPriceTimer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setShiftToLimitPriceTimer = function(value) {
  jspb.Message.setField(this, 8, value);
};


/**
 * optional int64 min_margin_required = 9;
 * @return {number}
 */
proto.UT.PROTO.WEB_POVConfiguration.prototype.getMinMarginRequired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_POVConfiguration.prototype.setMinMarginRequired = function(value) {
  jspb.Message.setField(this, 9, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_SmartOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_SmartOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_SmartOrder.displayName = 'proto.UT.PROTO.WEB_SmartOrder';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_SmartOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_SmartOrder} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_SmartOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    smartOrderRef: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clientId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    smartOrderType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    securityId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    exchangeId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    orderMode: jspb.Message.getFieldWithDefault(msg, 8, 0),
    orderType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    orderValidity: jspb.Message.getFieldWithDefault(msg, 10, 0),
    totalQuantity: jspb.Message.getFieldWithDefault(msg, 11, 0),
    filledQuantity: jspb.Message.getFieldWithDefault(msg, 12, 0),
    disclosedQuantity: jspb.Message.getFieldWithDefault(msg, 13, 0),
    status: jspb.Message.getFieldWithDefault(msg, 14, 0),
    startTime: jspb.Message.getFieldWithDefault(msg, 15, 0),
    endTime: jspb.Message.getFieldWithDefault(msg, 16, 0),
    executionMethod: jspb.Message.getFieldWithDefault(msg, 17, 0),
    limitPrice: jspb.Message.getFieldWithDefault(msg, 18, 0),
    marketLot: jspb.Message.getFieldWithDefault(msg, 19, 0),
    productType: jspb.Message.getFieldWithDefault(msg, 20, 0),
    twapConfig: (f = msg.getTwapConfig()) && proto.UT.PROTO.WEB_TWAPConfiguration.toObject(includeInstance, f),
    icebergConfig: (f = msg.getIcebergConfig()) && proto.UT.PROTO.WEB_IcebergConfiguration.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 23, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 24, 0),
    superBocoConfig: (f = msg.getSuperBocoConfig()) && proto.UT.PROTO.WEB_SuperBocoConfiguration.toObject(includeInstance, f),
    povConfig: (f = msg.getPovConfig()) && proto.UT.PROTO.WEB_POVConfiguration.toObject(includeInstance, f),
    setCustomExpiry: jspb.Message.getFieldWithDefault(msg, 27, false),
    expiryDate: jspb.Message.getFieldWithDefault(msg, 28, 0),
    strategyState: (f = msg.getStrategyState()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    calculatedValues: (f = msg.getCalculatedValues()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    platformType: jspb.Message.getFieldWithDefault(msg, 31, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_SmartOrder}
 */
proto.UT.PROTO.WEB_SmartOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_SmartOrder;
  return proto.UT.PROTO.WEB_SmartOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_SmartOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_SmartOrder}
 */
proto.UT.PROTO.WEB_SmartOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmartOrderRef(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientId(value);
      break;
    case 5:
      var value = /** @type {!proto.UT.PROTO.WEB_SmartOrderType} */ (reader.readEnum());
      msg.setSmartOrderType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSecurityId(value);
      break;
    case 7:
      var value = /** @type {!proto.UT.PROTO.ExchangeId} */ (reader.readEnum());
      msg.setExchangeId(value);
      break;
    case 8:
      var value = /** @type {!proto.UT.PROTO.OrderMode} */ (reader.readEnum());
      msg.setOrderMode(value);
      break;
    case 9:
      var value = /** @type {!proto.UT.PROTO.OrderType} */ (reader.readEnum());
      msg.setOrderType(value);
      break;
    case 10:
      var value = /** @type {!proto.UT.PROTO.OrderValidity} */ (reader.readEnum());
      msg.setOrderValidity(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalQuantity(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFilledQuantity(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDisclosedQuantity(value);
      break;
    case 14:
      var value = /** @type {!proto.UT.PROTO.WEB_SM_OrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartTime(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndTime(value);
      break;
    case 17:
      var value = /** @type {!proto.UT.PROTO.WEB_SM_ExecutionMethod} */ (reader.readEnum());
      msg.setExecutionMethod(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimitPrice(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMarketLot(value);
      break;
    case 20:
      var value = /** @type {!proto.UT.PROTO.ProductType} */ (reader.readEnum());
      msg.setProductType(value);
      break;
    case 21:
      var value = new proto.UT.PROTO.WEB_TWAPConfiguration;
      reader.readMessage(value,proto.UT.PROTO.WEB_TWAPConfiguration.deserializeBinaryFromReader);
      msg.setTwapConfig(value);
      break;
    case 22:
      var value = new proto.UT.PROTO.WEB_IcebergConfiguration;
      reader.readMessage(value,proto.UT.PROTO.WEB_IcebergConfiguration.deserializeBinaryFromReader);
      msg.setIcebergConfig(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 25:
      var value = new proto.UT.PROTO.WEB_SuperBocoConfiguration;
      reader.readMessage(value,proto.UT.PROTO.WEB_SuperBocoConfiguration.deserializeBinaryFromReader);
      msg.setSuperBocoConfig(value);
      break;
    case 26:
      var value = new proto.UT.PROTO.WEB_POVConfiguration;
      reader.readMessage(value,proto.UT.PROTO.WEB_POVConfiguration.deserializeBinaryFromReader);
      msg.setPovConfig(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetCustomExpiry(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiryDate(value);
      break;
    case 29:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setStrategyState(value);
      break;
    case 30:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setCalculatedValues(value);
      break;
    case 31:
      var value = /** @type {!proto.UT.PROTO.PlatformTypes} */ (reader.readEnum());
      msg.setPlatformType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_SmartOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_SmartOrder} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_SmartOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSmartOrderRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSmartOrderType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSecurityId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getExchangeId();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getOrderMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getOrderType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getOrderValidity();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getTotalQuantity();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getFilledQuantity();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getDisclosedQuantity();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getStartTime();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getEndTime();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getExecutionMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getLimitPrice();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getMarketLot();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getProductType();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getTwapConfig();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.UT.PROTO.WEB_TWAPConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getIcebergConfig();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.UT.PROTO.WEB_IcebergConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getSuperBocoConfig();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.UT.PROTO.WEB_SuperBocoConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getPovConfig();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.UT.PROTO.WEB_POVConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getSetCustomExpiry();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getExpiryDate();
  if (f !== 0) {
    writer.writeInt64(
      28,
      f
    );
  }
  f = message.getStrategyState();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getCalculatedValues();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getPlatformType();
  if (f !== 0.0) {
    writer.writeEnum(
      31,
      f
    );
  }
};


/**
 * optional int64 order_id = 2;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setOrderId = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional string smart_order_ref = 3;
 * @return {string}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getSmartOrderRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setSmartOrderRef = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional string client_id = 4;
 * @return {string}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setClientId = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional WEB_SmartOrderType smart_order_type = 5;
 * @return {!proto.UT.PROTO.WEB_SmartOrderType}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getSmartOrderType = function() {
  return /** @type {!proto.UT.PROTO.WEB_SmartOrderType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.UT.PROTO.WEB_SmartOrderType} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setSmartOrderType = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional int32 security_id = 6;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getSecurityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setSecurityId = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional ExchangeId exchange_id = 7;
 * @return {!proto.UT.PROTO.ExchangeId}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getExchangeId = function() {
  return /** @type {!proto.UT.PROTO.ExchangeId} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.UT.PROTO.ExchangeId} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setExchangeId = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional OrderMode order_mode = 8;
 * @return {!proto.UT.PROTO.OrderMode}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getOrderMode = function() {
  return /** @type {!proto.UT.PROTO.OrderMode} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.UT.PROTO.OrderMode} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setOrderMode = function(value) {
  jspb.Message.setField(this, 8, value);
};


/**
 * optional OrderType order_type = 9;
 * @return {!proto.UT.PROTO.OrderType}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getOrderType = function() {
  return /** @type {!proto.UT.PROTO.OrderType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.UT.PROTO.OrderType} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setOrderType = function(value) {
  jspb.Message.setField(this, 9, value);
};


/**
 * optional OrderValidity order_validity = 10;
 * @return {!proto.UT.PROTO.OrderValidity}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getOrderValidity = function() {
  return /** @type {!proto.UT.PROTO.OrderValidity} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.UT.PROTO.OrderValidity} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setOrderValidity = function(value) {
  jspb.Message.setField(this, 10, value);
};


/**
 * optional int64 total_quantity = 11;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getTotalQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setTotalQuantity = function(value) {
  jspb.Message.setField(this, 11, value);
};


/**
 * optional int64 filled_quantity = 12;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getFilledQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setFilledQuantity = function(value) {
  jspb.Message.setField(this, 12, value);
};


/**
 * optional int64 disclosed_quantity = 13;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getDisclosedQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setDisclosedQuantity = function(value) {
  jspb.Message.setField(this, 13, value);
};


/**
 * optional WEB_SM_OrderStatus status = 14;
 * @return {!proto.UT.PROTO.WEB_SM_OrderStatus}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getStatus = function() {
  return /** @type {!proto.UT.PROTO.WEB_SM_OrderStatus} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {!proto.UT.PROTO.WEB_SM_OrderStatus} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setStatus = function(value) {
  jspb.Message.setField(this, 14, value);
};


/**
 * optional int64 start_time = 15;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getStartTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setStartTime = function(value) {
  jspb.Message.setField(this, 15, value);
};


/**
 * optional int64 end_time = 16;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getEndTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setEndTime = function(value) {
  jspb.Message.setField(this, 16, value);
};


/**
 * optional WEB_SM_ExecutionMethod execution_method = 17;
 * @return {!proto.UT.PROTO.WEB_SM_ExecutionMethod}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getExecutionMethod = function() {
  return /** @type {!proto.UT.PROTO.WEB_SM_ExecutionMethod} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {!proto.UT.PROTO.WEB_SM_ExecutionMethod} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setExecutionMethod = function(value) {
  jspb.Message.setField(this, 17, value);
};


/**
 * optional int64 limit_price = 18;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setLimitPrice = function(value) {
  jspb.Message.setField(this, 18, value);
};


/**
 * optional int64 market_lot = 19;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getMarketLot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setMarketLot = function(value) {
  jspb.Message.setField(this, 19, value);
};


/**
 * optional ProductType product_type = 20;
 * @return {!proto.UT.PROTO.ProductType}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getProductType = function() {
  return /** @type {!proto.UT.PROTO.ProductType} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {!proto.UT.PROTO.ProductType} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setProductType = function(value) {
  jspb.Message.setField(this, 20, value);
};


/**
 * optional WEB_TWAPConfiguration twap_config = 21;
 * @return {?proto.UT.PROTO.WEB_TWAPConfiguration}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getTwapConfig = function() {
  return /** @type{?proto.UT.PROTO.WEB_TWAPConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.UT.PROTO.WEB_TWAPConfiguration, 21));
};


/** @param {?proto.UT.PROTO.WEB_TWAPConfiguration|undefined} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setTwapConfig = function(value) {
  jspb.Message.setWrapperField(this, 21, value);
};


proto.UT.PROTO.WEB_SmartOrder.prototype.clearTwapConfig = function() {
  this.setTwapConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.hasTwapConfig = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional WEB_IcebergConfiguration iceberg_config = 22;
 * @return {?proto.UT.PROTO.WEB_IcebergConfiguration}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getIcebergConfig = function() {
  return /** @type{?proto.UT.PROTO.WEB_IcebergConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.UT.PROTO.WEB_IcebergConfiguration, 22));
};


/** @param {?proto.UT.PROTO.WEB_IcebergConfiguration|undefined} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setIcebergConfig = function(value) {
  jspb.Message.setWrapperField(this, 22, value);
};


proto.UT.PROTO.WEB_SmartOrder.prototype.clearIcebergConfig = function() {
  this.setIcebergConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.hasIcebergConfig = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional int64 created_at = 23;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setCreatedAt = function(value) {
  jspb.Message.setField(this, 23, value);
};


/**
 * optional int64 updated_at = 24;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setUpdatedAt = function(value) {
  jspb.Message.setField(this, 24, value);
};


/**
 * optional WEB_SuperBocoConfiguration super_boco_config = 25;
 * @return {?proto.UT.PROTO.WEB_SuperBocoConfiguration}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getSuperBocoConfig = function() {
  return /** @type{?proto.UT.PROTO.WEB_SuperBocoConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.UT.PROTO.WEB_SuperBocoConfiguration, 25));
};


/** @param {?proto.UT.PROTO.WEB_SuperBocoConfiguration|undefined} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setSuperBocoConfig = function(value) {
  jspb.Message.setWrapperField(this, 25, value);
};


proto.UT.PROTO.WEB_SmartOrder.prototype.clearSuperBocoConfig = function() {
  this.setSuperBocoConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.hasSuperBocoConfig = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional WEB_POVConfiguration pov_config = 26;
 * @return {?proto.UT.PROTO.WEB_POVConfiguration}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getPovConfig = function() {
  return /** @type{?proto.UT.PROTO.WEB_POVConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.UT.PROTO.WEB_POVConfiguration, 26));
};


/** @param {?proto.UT.PROTO.WEB_POVConfiguration|undefined} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setPovConfig = function(value) {
  jspb.Message.setWrapperField(this, 26, value);
};


proto.UT.PROTO.WEB_SmartOrder.prototype.clearPovConfig = function() {
  this.setPovConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.hasPovConfig = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool set_custom_expiry = 27;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getSetCustomExpiry = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 27, false));
};


/** @param {boolean} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setSetCustomExpiry = function(value) {
  jspb.Message.setField(this, 27, value);
};


/**
 * optional int64 expiry_date = 28;
 * @return {number}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getExpiryDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setExpiryDate = function(value) {
  jspb.Message.setField(this, 28, value);
};


/**
 * optional google.protobuf.Any strategy_state = 29;
 * @return {?proto.google.protobuf.Any}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getStrategyState = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 29));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setStrategyState = function(value) {
  jspb.Message.setWrapperField(this, 29, value);
};


proto.UT.PROTO.WEB_SmartOrder.prototype.clearStrategyState = function() {
  this.setStrategyState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.hasStrategyState = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.Any calculated_values = 30;
 * @return {?proto.google.protobuf.Any}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getCalculatedValues = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 30));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setCalculatedValues = function(value) {
  jspb.Message.setWrapperField(this, 30, value);
};


proto.UT.PROTO.WEB_SmartOrder.prototype.clearCalculatedValues = function() {
  this.setCalculatedValues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.hasCalculatedValues = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional PlatformTypes platform_type = 31;
 * @return {!proto.UT.PROTO.PlatformTypes}
 */
proto.UT.PROTO.WEB_SmartOrder.prototype.getPlatformType = function() {
  return /** @type {!proto.UT.PROTO.PlatformTypes} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/** @param {!proto.UT.PROTO.PlatformTypes} value */
proto.UT.PROTO.WEB_SmartOrder.prototype.setPlatformType = function(value) {
  jspb.Message.setField(this, 31, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_OrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_OrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_OrderResponse.displayName = 'proto.UT.PROTO.WEB_OrderResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_OrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_OrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_OrderResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_OrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    smartOrderRef: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_OrderResponse}
 */
proto.UT.PROTO.WEB_OrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_OrderResponse;
  return proto.UT.PROTO.WEB_OrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_OrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_OrderResponse}
 */
proto.UT.PROTO.WEB_OrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmartOrderRef(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_OrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_OrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_OrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_OrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmartOrderRef();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string smart_order_ref = 1;
 * @return {string}
 */
proto.UT.PROTO.WEB_OrderResponse.prototype.getSmartOrderRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_OrderResponse.prototype.setSmartOrderRef = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.UT.PROTO.WEB_OrderResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_OrderResponse.prototype.setStatus = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.UT.PROTO.WEB_OrderResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_OrderResponse.prototype.setMessage = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.UT.PROTO.WEB_OrderResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.WEB_OrderResponse.prototype.setCreatedAt = function(value) {
  jspb.Message.setField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_ValidationError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.WEB_ValidationError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_ValidationError.displayName = 'proto.UT.PROTO.WEB_ValidationError';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_ValidationError.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_ValidationError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_ValidationError} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_ValidationError.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_ValidationError}
 */
proto.UT.PROTO.WEB_ValidationError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_ValidationError;
  return proto.UT.PROTO.WEB_ValidationError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_ValidationError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_ValidationError}
 */
proto.UT.PROTO.WEB_ValidationError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_ValidationError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_ValidationError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_ValidationError} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_ValidationError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string field = 1;
 * @return {string}
 */
proto.UT.PROTO.WEB_ValidationError.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_ValidationError.prototype.setField = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.UT.PROTO.WEB_ValidationError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_ValidationError.prototype.setMessage = function(value) {
  jspb.Message.setField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.WEB_ErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.WEB_ErrorResponse.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.WEB_ErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.WEB_ErrorResponse.displayName = 'proto.UT.PROTO.WEB_ErrorResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.WEB_ErrorResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.WEB_ErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.WEB_ErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.WEB_ErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.WEB_ErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: jspb.Message.getFieldWithDefault(msg, 1, ""),
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.UT.PROTO.WEB_ValidationError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.WEB_ErrorResponse}
 */
proto.UT.PROTO.WEB_ErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.WEB_ErrorResponse;
  return proto.UT.PROTO.WEB_ErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.WEB_ErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.WEB_ErrorResponse}
 */
proto.UT.PROTO.WEB_ErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 2:
      var value = new proto.UT.PROTO.WEB_ValidationError;
      reader.readMessage(value,proto.UT.PROTO.WEB_ValidationError.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.WEB_ErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.WEB_ErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.WEB_ErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.WEB_ErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.UT.PROTO.WEB_ValidationError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string error = 1;
 * @return {string}
 */
proto.UT.PROTO.WEB_ErrorResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.UT.PROTO.WEB_ErrorResponse.prototype.setError = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * repeated WEB_ValidationError details = 2;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<!proto.UT.PROTO.WEB_ValidationError>}
 */
proto.UT.PROTO.WEB_ErrorResponse.prototype.getDetailsList = function() {
  return /** @type{!Array.<!proto.UT.PROTO.WEB_ValidationError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UT.PROTO.WEB_ValidationError, 2));
};


/** @param {!Array.<!proto.UT.PROTO.WEB_ValidationError>} value */
proto.UT.PROTO.WEB_ErrorResponse.prototype.setDetailsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.UT.PROTO.WEB_ValidationError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UT.PROTO.WEB_ValidationError}
 */
proto.UT.PROTO.WEB_ErrorResponse.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.UT.PROTO.WEB_ValidationError, opt_index);
};


proto.UT.PROTO.WEB_ErrorResponse.prototype.clearDetailsList = function() {
  this.setDetailsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.SuperOrderBookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.SuperOrderBookResponse.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.SuperOrderBookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.SuperOrderBookResponse.displayName = 'proto.UT.PROTO.SuperOrderBookResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.SuperOrderBookResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.SuperOrderBookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.SuperOrderBookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.SuperOrderBookResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.SuperOrderBookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    superOrderBookDetailsList: jspb.Message.toObjectList(msg.getSuperOrderBookDetailsList(),
    proto.UT.PROTO.WEB_SmartOrder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.SuperOrderBookResponse}
 */
proto.UT.PROTO.SuperOrderBookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.SuperOrderBookResponse;
  return proto.UT.PROTO.SuperOrderBookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.SuperOrderBookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.SuperOrderBookResponse}
 */
proto.UT.PROTO.SuperOrderBookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.UT.PROTO.WEB_SmartOrder;
      reader.readMessage(value,proto.UT.PROTO.WEB_SmartOrder.deserializeBinaryFromReader);
      msg.addSuperOrderBookDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.SuperOrderBookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.SuperOrderBookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.SuperOrderBookResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.SuperOrderBookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuperOrderBookDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.UT.PROTO.WEB_SmartOrder.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WEB_SmartOrder super_order_book_details = 1;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<!proto.UT.PROTO.WEB_SmartOrder>}
 */
proto.UT.PROTO.SuperOrderBookResponse.prototype.getSuperOrderBookDetailsList = function() {
  return /** @type{!Array.<!proto.UT.PROTO.WEB_SmartOrder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UT.PROTO.WEB_SmartOrder, 1));
};


/** @param {!Array.<!proto.UT.PROTO.WEB_SmartOrder>} value */
proto.UT.PROTO.SuperOrderBookResponse.prototype.setSuperOrderBookDetailsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.UT.PROTO.WEB_SmartOrder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UT.PROTO.WEB_SmartOrder}
 */
proto.UT.PROTO.SuperOrderBookResponse.prototype.addSuperOrderBookDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.UT.PROTO.WEB_SmartOrder, opt_index);
};


proto.UT.PROTO.SuperOrderBookResponse.prototype.clearSuperOrderBookDetailsList = function() {
  this.setSuperOrderBookDetailsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.SuperOrderBookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.SuperOrderBookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.SuperOrderBookRequest.displayName = 'proto.UT.PROTO.SuperOrderBookRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.SuperOrderBookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.SuperOrderBookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.SuperOrderBookRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.SuperOrderBookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.SuperOrderBookRequest}
 */
proto.UT.PROTO.SuperOrderBookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.SuperOrderBookRequest;
  return proto.UT.PROTO.SuperOrderBookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.SuperOrderBookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.SuperOrderBookRequest}
 */
proto.UT.PROTO.SuperOrderBookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.SuperOrderBookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.SuperOrderBookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.SuperOrderBookRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.SuperOrderBookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string client = 1;
 * @return {string}
 */
proto.UT.PROTO.SuperOrderBookRequest.prototype.getClient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.UT.PROTO.SuperOrderBookRequest.prototype.setClient = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SmartOrderType = {
  SMART_ORDER_TYPE_UNSPECIFIED: 0,
  SMART_ORDER_TYPE_TWAP: 1,
  SMART_ORDER_TYPE_ICEBERG: 2,
  SMART_ORDER_TYPE_SUPER_BOCO: 3,
  SMART_ORDER_TYPE_POV: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_OrderStatus = {
  ORDER_STATUS_UNSPECIFIED: 0,
  ORDER_STATUS_PENDING: 1,
  ORDER_STATUS_ACTIVE: 2,
  ORDER_STATUS_COMPLETED: 3,
  ORDER_STATUS_CANCELLED: 4,
  ORDER_STATUS_FAILED: 5,
  ORDER_STATUS_PAUSED: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_FeEventType = {
  FE_EVENT_TYPE_UNSPECIFED: 0,
  FE_EVENT_TYPE_CREATED: 1,
  FE_EVENT_TYPE_MODIFIED: 2,
  FE_EVENT_TYPE_CANCELLED: 3,
  FE_EVENT_TYPE_COMPLETED: 4,
  FE_EVENT_TYPE_FAILED: 5,
  FE_EVENT_TYPE_PAUSED: 6,
  FE_EVENT_TYPE_RESUMED: 7,
  FE_EVENT_TYPE_ACTIVE: 8,
  FE_EVENT_TYPE_ORDER_CONFIRMATION: 9
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_ExecutionMethod = {
  EXECUTION_METHOD_UNSPECIFIED: 0,
  EXECUTION_METHOD_BEST_PRICE: 1,
  EXECUTION_METHOD_QUICK_FILL: 2,
  EXECUTION_METHOD_LOWEST: 3,
  EXECUTION_METHOD_LIMIT_PRICE: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_SliceStatus = {
  SLICE_STATUS_UNSPECIFIED: 0,
  SLICE_STATUS_PENDING: 1,
  SLICE_STATUS_SCHEDULED: 2,
  SLICE_STATUS_EXECUTING: 3,
  SLICE_STATUS_PARTIAL: 4,
  SLICE_STATUS_COMPLETED: 5,
  SLICE_STATUS_FAILED: 6,
  SLICE_STATUS_CANCELLED: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_EventType = {
  EVENT_TYPE_UNSPECIFIED: 0,
  EVENT_TYPE_TIME_CONDITION: 1,
  EVENT_TYPE_ORDER_CONFIRMATION: 2,
  EVENT_TYPE_CONFIG_CHANGE: 3,
  EVENT_TYPE_MARKET_DATA: 4,
  EVENT_TYPE_INIT: 5,
  EVENT_TYPE_LOAD: 6,
  EVENT_TYPE_RESYNC: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_StrategyStatus = {
  STRATEGY_STATUS_UNSPECIFIED: 0,
  STRATEGY_STATUS_PENDING: 1,
  STRATEGY_STATUS_ACTIVE: 2,
  STRATEGY_STATUS_PAUSED: 3,
  STRATEGY_STATUS_COMPLETED: 4,
  STRATEGY_STATUS_FAILED: 5,
  STRATEGY_STATUS_CANCELLED: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WEB_SM_TransactionType = {
  WEB_SM_TRANSACTION_TYPE_CREATE: 0,
  WEB_SM_TRANSACTION_TYPE_MODIFY: 1,
  WEB_SM_TRANSACTION_TYPE_CANCEL: 2
};

goog.object.extend(exports, proto.UT.PROTO);
